module.exports = "/_next/static/images/female-seated-toilet@2x-min-7823387834a312dbcd7db7ecfe146154.jpg";